import { QuickCallAdminFormPage } from '@/modules/meetings';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(QuickCallAdminFormPage, {
  requiresEvery: [RouteRestrictions.ADMIN_ROLE],
});
